import React from 'react';

const NonAuthLayout = (props: { children: React.ReactNode }) => {
  return (
    <React.Fragment>{props.children}</React.Fragment>
  );
}

export default NonAuthLayout;
